/*
 * File: index.tsx
 * Desc: 弹窗容器
 * File Created: 2019-08-18 23:18:40
 * Author: chenghao at <hao.cheng@karakal.com.cn>
 * ------
 * Copyright 2019 - present, karakal
 */
import React, { useState, useImperativeHandle } from 'react';
import { Modal } from 'antd';
import classNames from 'classnames';
import { ModalProps } from 'antd/lib/modal';

interface ModalContainerProps extends ModalProps {
    style?: React.CSSProperties;
    className?: string;
    children: any;
    destroyOnClose?: boolean;
    onOk?: () => void;
    onCancel?: () => void;
    /** 是否自动关闭弹窗 */
    autoClose?: boolean;
}
export interface IFModalRef {
    open: () => any;
    close: () => any;
}
export const ModalContainer: React.FC<ModalContainerProps> = (
    {
        title,
        style,
        className,
        children,
        onOk,
        onCancel,
        destroyOnClose,
        forceRender,
        autoClose = true,
        width = 946,
        maskClosable = false,
        ...restProps
    },
    ref
) => {
    const [visible, setVisible] = useState(false);
    useImperativeHandle(
        ref,
        (): IFModalRef => ({
            open: () => changeModalVisible(true),
            close: () => changeModalVisible(false),
        })
    );
    const handleOk = (): void => {
        onOk && onOk();
        autoClose && changeModalVisible(false);
    };
    const handleCancel = (): void => {
        changeModalVisible(false);
        onCancel && onCancel();
    };
    /**
     * 更改弹窗的状态值
     * @param flag 状态值
     */
    const changeModalVisible = (flag: boolean = true): void => {
        setVisible(flag);
    };
    return (
        <Modal
            onOk={handleOk}
            onCancel={handleCancel}
            maskClosable={maskClosable}
            className={classNames('modal-theme-header', className)}
            {...{
                visible,
                title,
                style,
                destroyOnClose,
                forceRender,
                ...(((style && !style.width) || !style) && { width }),
                ...restProps,
            }}
            // cancelText="取消"
            // okText="确定"
        >
            {children}
        </Modal>
    );
};

export default React.forwardRef(ModalContainer);
